export default {
  "nav.bank.payments": "Kohdistukset",
  "nav.bank.overview": "Allocation overview",
  "nav.bulk_invoicing": "Bulk invoicing",
  "nav.bank.enable_banking": "Bank connections",
  "nav.me": "My desktop",
};
